export const baseEvent = {
  context: 'NOTIFICATION',
} as const
